module.exports = __webpack_public_path__ + "media/images/austria-964aeff3.png";